// A menu link is active when it points to the current page (and section, for #hash links).
const trimSlash = (value) => value.replace(/\/+$/, '');

const isActiveLink = (linkPath, { pathname, hash }) => {
  const [path, anchor] = linkPath.split('#');
  if (trimSlash(path) !== trimSlash(pathname)) return false;
  return anchor ? hash === `#${anchor}` : true;
};

// Some pages live in more than one menu (e.g. Seguridad is in Plataforma and Recursos).
// We remember which menu the user clicked so only that one is marked.
const STORAGE_KEY = 'smile.navSection';

export const rememberSection = (sectionKey, linkPath) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ sectionKey, path: linkPath.split('#')[0] }));
  } catch (e) {
    // storage unavailable: falls back to the first matching menu
  }
};

const readRemembered = () => {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || null;
  } catch (e) {
    return null;
  }
};

// key of the single menu that should be marked for the current page (or null)
export const activeSectionKey = (items, pathname) => {
  const matches = items
    .filter((item) => item.menu)
    .filter((item) => item.menu.some((col) => col.links.some((link) => {
      if (!link.path) return false; // loading skeletons have no path
      const path = trimSlash(link.path.split('#')[0]);
      return path && trimSlash(pathname).startsWith(path);
    })))
    .map((item) => item.key);
  if (!matches.length) return null;
  const remembered = readRemembered();
  if (remembered && matches.includes(remembered.sectionKey)
    && trimSlash(pathname).startsWith(trimSlash(remembered.path))) {
    return remembered.sectionKey;
  }
  return matches[0];
};

export default isActiveLink;
